















































import { Vue, Component, Prop } from 'vue-property-decorator';
const Multiple = 'multiple';
@Component
export default class RkSelect extends Vue {
  @Prop() public mode: any;
  @Prop() public data!: any;
  @Prop() public current!: any;
  public search: string = '';
  public visible: boolean = false;

  get filterData() {
    return this.data.filter((i: any) => i.label.toUpperCase().indexOf(this.search.toUpperCase()) !== -1);
  }

  get selectedOpt() {
    return this.mode === Multiple ? this.current.map((item: any) => item.key) : [this.current.key];
  }

  public handleOpen() {
    this.visible = true;
  }

  public handleSelect(i: any) {
    const selected = this.mode === Multiple ? this.current.map((item: any) => item.key) : [this.current.key];
    if (selected.includes(i.key)) {
      return;
    }
    this.$emit('onChoose', i);
    this.visible = false;
  }

  private removeSelected(item: any) {
    if (this.mode === Multiple) {
      this.$emit('onChoose', item);
    }
  }
}
